
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Globe } from "lucide-react";

interface GeneralSettingsCardProps {
  siteTitle: string;
  siteDescription: string;
  onInputChange: (field: string, value: string) => void;
}

export const GeneralSettingsCard = ({
  siteTitle,
  siteDescription,
  onInputChange,
}: GeneralSettingsCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5 text-teedee-blue" />
          General Settings
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="site_title">Site Title</Label>
          <Input
            id="site_title"
            value={siteTitle}
            onChange={(e) => onInputChange("site_title", e.target.value)}
            placeholder="Your Site Title"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="site_description">Site Description</Label>
          <Textarea
            id="site_description"
            value={siteDescription}
            onChange={(e) => onInputChange("site_description", e.target.value)}
            className="min-h-[100px]"
            placeholder="Describe your site..."
          />
        </div>
      </CardContent>
    </Card>
  );
};
